import React from 'react';
import SessionDetail from './SessionDetail';

const SessionDetailPane = ({ sessionId, onClose, onCompare }) => {
  return (
    <div className="detail-wrapper">
      <div className="detail-header sticky">
        <button className="ghost" onClick={onClose} aria-label="Back to timeline">← Back</button>
        <div className="spacer" />
        <button className="accent" onClick={onCompare} aria-label="Compare sessions">Compare</button>
      </div>
      <div className="detail-body fade-in">
        <SessionDetail sessionId={sessionId} onBack={onClose} onCompare={onCompare} hideHeader />
      </div>
    </div>
  );
};

export default SessionDetailPane;

